import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import {
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  AccountBalance as AccountBalanceIcon,
  AttachMoney as AttachMoneyIcon,
  ShowChart as ShowChartIcon,
  Assessment as AssessmentIcon
} from '@mui/icons-material';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const FundSummaryCards = ({ summary, isLoading }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  const cards = [
    {
      title: 'Total Deposits',
      value: summary?.allTime?.totalDeposits || 0,
      icon: <TrendingUpIcon style={{ fontSize: '32px', color: '#2af598' }} />,
      borderColor: 'rgba(42, 245, 152, 0.2)',
      iconColor: '#2af598'
    },
    {
      title: 'Total Withdrawals',
      value: summary?.allTime?.totalWithdrawals || 0,
      icon: <TrendingDownIcon style={{ fontSize: '32px', color: '#f52a2d' }} />,
      borderColor: 'rgba(245, 42, 45, 0.2)',
      iconColor: '#f52a2d'
    },
    {
      title: 'Performance Paid',
      value: summary?.allTime?.totalNetPerformance || 0,
      icon: <ShowChartIcon style={{ fontSize: '32px', color: '#2196f3' }} />,
      borderColor: 'rgba(33, 150, 243, 0.2)',
      iconColor: '#2196f3'
    },
    {
      title: 'Commissions Earned',
      value: summary?.allTime?.totalCommissions || 0,
      icon: <AttachMoneyIcon style={{ fontSize: '32px', color: '#9c27b0' }} />,
      borderColor: 'rgba(156, 39, 176, 0.2)',
      iconColor: '#9c27b0'
    },
    {
      title: 'Current AUM',
      value: summary?.current?.aum || 0,
      icon: <AccountBalanceIcon style={{ fontSize: '32px', color: '#ffc107' }} />,
      borderColor: 'rgba(255, 193, 7, 0.2)',
      iconColor: '#ffc107'
    },
    {
      title: 'Net Fund Growth',
      value: summary?.allTime?.netFundGrowth || 0,
      icon: <AssessmentIcon style={{ fontSize: '32px', color: '#2af598' }} />,
      borderColor: 'rgba(42, 245, 152, 0.2)',
      iconColor: '#2af598',
      isGradient: true
    }
  ];

  return (
    <Grid container spacing={2}>
      {cards.map((card, index) => (
        <Grid item xs={12} sm={6} md={4} lg={2} key={index}>
          {isLoading ? (
            <Skeleton height={120} style={{ borderRadius: '8px' }} />
          ) : (
            <Card
              sx={{
                background: card.isGradient
                  ? 'linear-gradient(135deg, #353535 0%, #1e1e1e 100%)'
                  : 'linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%)',
                border: `1px solid ${card.borderColor}`,
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
                height: '100%',
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.4)'
                }
              }}
            >
              <CardContent sx={{ p: 2 }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: '14px',
                        fontWeight: '500',
                        color: '#ccc'
                      }}
                    >
                      {card.title}
                    </Typography>
                    {card.icon}
                  </Box>
                  <Typography
                    sx={{
                      fontSize: '22px',
                      fontWeight: '700',
                      color: '#fff',
                      wordBreak: 'break-word'
                    }}
                  >
                    {formatCurrency(card.value)}
                  </Typography>
                  {card.title === 'Current AUM' && summary?.current?.activeClients && (
                    <Typography
                      sx={{
                        fontSize: '12px',
                        color: '#aaa',
                        mt: 0.5
                      }}
                    >
                      {summary.current.activeClients} Active Clients
                    </Typography>
                  )}
                </Box>
              </CardContent>
            </Card>
          )}
        </Grid>
      ))}
    </Grid>
  );
};

export default FundSummaryCards;

